import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { IPeriodPickerContainer } from '@/types';
import { MapActions, MapGetters } from '@/utils';
import { PeriodPicker } from '@/components';

@Component({
  name: 'PeriodPickerContainer',
})
export default class PeriodPickerContainer extends Vue implements IPeriodPickerContainer {
  @Prop({type: String}) public readonly startDate!: string | null;
  @Prop({type: String}) public readonly maxDate!: string | null;
  @Prop({type: Boolean}) public readonly mobile!: boolean;
  @Prop({type: Boolean, default: false}) public readonly readonly!: boolean;
  @PropSync('endDate', {type: String}) public syncedEndDate!: string;

  @MapGetters(['periodPickerData', 'translations'])

  @MapActions(['setPeriodPickerValue'])

  public periodPickerData;
  public setPeriodPickerValue;
  public translations;

  private get value() {
    return this.periodPickerData.value || this.periodPickerData.default;
  }

  private set value(value) {
    this.setPeriodPickerValue(value);
  }

  private get limits() {
    if (!!this.maxDate) {
      const end = this.$dayjs(this.maxDate);
      const now = this.$dayjs();
      const adEndDate = end.diff(now, 'month');
      const max = adEndDate > this.periodPickerData.limits.max ? this.periodPickerData.limits.max : adEndDate;
      return {
        min: this.periodPickerData.limits.min,
        max,
      };
    } else {
      return this.periodPickerData.limits;
    }
  }

  private render(createElement: CreateElement) {
    return createElement(PeriodPicker, {
      props: {
        readonly: this.readonly,
        mobile: this.$vuetify.breakpoint.xsOnly,
        translation: this.translations.period_picker,
        limits: this.limits,
        value: this.value,
        startDate: this.startDate || new Date().toISOString().substr(0, 10),
        presets: this.translations.period_picker.presets,
      },
      on: {
        change: (value) => this.value = value,
        'update:endDate': (value) => this.syncedEndDate = value,
      },
    });
  }
}
